import React from 'react';
import Table from 'react-bootstrap/Table';
import AppModal from '../ui/AppModal';

function RequirementClaimsModal({ show, onHide, subtitle, claimedUsers = [] }) {
  return (
    <AppModal
      show={show}
      onHide={onHide}
      title="Claimed Recruiters"
      subtitle={subtitle}
      size="lg"
    >
      {claimedUsers.length === 0 ? (
        <p className="hr-empty-state">No recruiters have claimed this requirement yet.</p>
      ) : (
        <div className="table-responsive">
          <Table bordered hover responsive className="hr-table table-sm">
            <thead>
              <tr>
                <th>Employee Code</th>
                <th>Employee Name</th>
              </tr>
            </thead>
            <tbody>
              {claimedUsers.map((user, index) => (
                <tr key={user._id || user.EmpCode || index}>
                  <td>{user.EmpCode || '—'}</td>
                  <td>{user.EmployeeName || '—'}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </AppModal>
  );
}

export default RequirementClaimsModal;
